export default "__VITE_ASSET__BIrILIyg__"